import React from 'react';

/**
 * FilterSelect — a clean labeled select for admin filter bars
 *
 * Props:
 *   label       {string}  label text shown above / left of select
 *   name        {string}  name attribute
 *   value       {any}     controlled value
 *   onChange    {fn}      (value) => void — called with raw value (not event)
 *   options     {Array}   [{ label: string, value: any }]
 *   placeholder {string}  first "empty" option label, default "All"
 *   width       {number}  optional min-width in px
 */
const FilterSelect = ({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = 'All',
  width,
}) => {
  const id = `filter-select-${name}`;
  return (
    <div className="adm-filter-select">
      <div className="adm-filter-select__wrap">
        <select
          id={id}
          name={name}
          className="adm-filter-select__select"
          value={value === null || value === undefined ? '' : value}
          onChange={e => typeof onChange === 'function' && onChange(e.target.value)}
          style={width ? { minWidth: width } : undefined}
        >
          <option value="">{placeholder}</option>
          {options.map((opt, i) => (
            <option key={i} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <i className="fa fa-chevron-down adm-filter-select__chevron" aria-hidden="true" />
        {value !== '' && value !== null && value !== undefined && (
          <button
            type="button"
            className="adm-filter-select__clear"
            onClick={() => typeof onChange === 'function' && onChange('')}
            title={`Clear ${label || name}`}
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterSelect;
